/**
 * Cart checkout — account gate
 *
 * If a signed-out visitor clicks the checkout button, redirect them to the
 * account type page instead of letting the form submit to /checkout.
 * Signed-in customers are unaffected — the button simply lacks the
 * data-requires-account attribute for them (set server-side in Liquid).
 */
document.addEventListener('DOMContentLoaded', function () {
  var checkoutButton = document.getElementById('checkout');

  if (!checkoutButton || !checkoutButton.dataset.requiresAccount) {
    return;
  }

  checkoutButton.addEventListener('click', function (event) {
    event.preventDefault();

    var accountUrl = checkoutButton.dataset.accountUrl;
    if (accountUrl) {
      window.location.href = accountUrl;
    }
  });
});